import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'

export class GoogleView extends Component {

  render() {
    const { url } = this.props
    return (<iframe title="Google View" frameBorder="0" style={{ width: '100%', height: '100vh' }} src={`https://docs.google.com/gview?url=${url}&embedded=true&pid=explorer&efh=false&a=v&chrome=false`}></iframe>)
  }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {

}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(GoogleView)))